import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function ProtectedRoute({ component: Component, redirectPath = "/" }) {
  const isAuthenticated = useSelector((state) => state.Auth.AdminAuth);
  const navigate = useNavigate();


  
  useEffect(() => {
    if (isAuthenticated == false) { 
      navigate(redirectPath);
    }
  }, [isAuthenticated, navigate, redirectPath]);

  if (isAuthenticated == false) { 
    return null;
  }

  return <Component />;
}

export default ProtectedRoute;
